import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import { VODOPAD_ENDPOINT } from './config/runtime'

async function bootstrap() {
  if (import.meta.env.VITE_FLUENCE_CLIENT_NETWORK === 'test') {
    const { worker } = await import('./test/mocks/browser')
    const apiOrigin = new URL(VODOPAD_ENDPOINT).origin
    await worker.start({
      onUnhandledRequest(request, print) {
        if (request.url.startsWith(apiOrigin)) {
          print.error()
        }
      },
    })
  }

  const root = document.getElementById('root')
  if (!root) throw new Error('Root element not found')

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

void bootstrap()
